import { render, staticRenderFns } from "./QuizPointConfig.vue?vue&type=template&id=fbcda022&scoped=true&"
import script from "./QuizPointConfig.vue?vue&type=script&lang=js&"
export * from "./QuizPointConfig.vue?vue&type=script&lang=js&"
import style0 from "./QuizPointConfig.vue?vue&type=style&index=0&id=fbcda022&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbcda022",
  null
  
)

export default component.exports